export default __webpack_public_path__ + "static/media/RD-3.115f9ca4.jpeg";